import { render, staticRenderFns } from "./starList.vue?vue&type=template&id=7bd51e01&scoped=true&"
import script from "./starList.vue?vue&type=script&lang=js&"
export * from "./starList.vue?vue&type=script&lang=js&"
import style0 from "./starList.vue?vue&type=style&index=0&id=7bd51e01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd51e01",
  null
  
)

export default component.exports